import { request } from "../../request";
import confs from '../../configurations';

const { URL_API } = confs;

export default {
    fetchClients: () => request.get(URL_API + '/clients'),
    fetchClientsPaginated: (page = 1, limit = 10, search = '', sortBy = 'lastSalesRevenue', sortOrder = 'DESC') => {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
            ...(search && { search }),
            ...(sortBy && { sortBy }),
            ...(sortOrder && { sortOrder })
        });
        return request.get(`${URL_API}/clients/paginated?${params.toString()}`);
    },
    fetchClient: (id) => request.get(URL_API + '/clients/' + id),
    postClient: (client) => request.post(URL_API + '/clients', client),
    deleteClient: (id) => request.delete(URL_API + '/clients/' + id),
    generateShortener: (id) => request.post(URL_API + '/clients/' + id + '/shorteners'),
    refreshShortener: (id) => request.post(URL_API + '/clients/' + id + '/shorteners/refresh'),
    invalidateShortener: (id) => request.post(URL_API + '/clients/' + id + '/shorteners/invalidate'),
};